export default class Material{
    constructor(gl,{vertexShader, fragmentShader, uniforms}){
        this.gl = gl;
        this.compile({vertexShader, fragmentShader, uniforms});
    }

    compile({vertexShader, fragmentShader, uniforms}){
        let compiledVertexShader = createShader(this.gl, vertexShader, this.gl.VERTEX_SHADER);
        let compiledFragmentShader = createShader(this.gl,fragmentPrecision + fragmentShader, this.gl.FRAGMENT_SHADER);
        if(compiledVertexShader.status && compiledFragmentShader.status){
            this.program = this.gl.createProgram();

            this.rawVertexShader = vertexShader;
            this.rawFragmentShader = fragmentShader;
            this.rawUniforms = uniforms;
            
            this.vertexShader = compiledVertexShader.shader;
            this.fragmentShader = compiledFragmentShader.shader;

            this.gl.attachShader(this.program, this.vertexShader);
            this.gl.attachShader(this.program, this.fragmentShader);

            this.gl.linkProgram(this.program);

            this.attributes = {
                vertexPosition: this.gl.getAttribLocation(this.program, 'a_position'),
                textureCoord: this.gl.getAttribLocation(this.program, 'a_textureCord'),
            };

            this.uniforms = {};
            let textureUnit = 0;
            Object.entries(uniforms).forEach(([key,value]) => {
                this.uniforms[key] = new Uniform(this.gl,this.program, value);
                if(this.uniforms[key].type == "t"){
                    this.uniforms[key].textureUnit = textureUnit;
                    textureUnit++;
                }
            });
        }
        return {
            fragment: compiledFragmentShader,
            vertex: compiledVertexShader,
        }
    }

    updateFragmentShader(fragmentShader){
        return this.compile({vertexShader: this.rawVertexShader, fragmentShader, uniforms: this.rawUniforms});
    }

    resetUniforms(){
        
    }

    use(){
        if(this.program){
            this.gl.useProgram(this.program);
            Object.values(this.uniforms).forEach(uniform => uniform.apply())
        }
    }
}

class Uniform{
    constructor(gl, program, {name, type, size, value}){
        this.gl = gl;
        this.program = program;
        this.location = this.gl.getUniformLocation(program, name);
        this.name = name;
        this.type = type;
        this.size = size;
        this.value = value;
        this.textureUnit = -1;
    }

    apply(){
        if(this.value != null){
            switch(this.type){
                case "f": return this.applyVector();
                case "t": return this.applyTexture();
                case "m": return this.applyMatrix();
                default: throw "Unknow uniform type";
            }
        }
    }

    applyVector(){
        const value = this.value.length ? this.value : [this.value];
        this.gl[`uniform${this.size}f`](this.location, ...value);
    }

    applyTexture(){
        if(this.value){
            this.gl.activeTexture(this.gl.TEXTURE0 + this.textureUnit);
            this.gl.bindTexture(this.gl.TEXTURE_2D, this.value);
            this.gl.uniform1i(this.location, this.textureUnit);
        }
    }

    applyMatrix(){
        this.gl[`uniformMatrix${this.size}fv`](this.location, false, this.value);
    }
}

const createShader = (gl, sourceCode, type) => {
    // Compiles either a shader of type gl.VERTEX_SHADER or gl.FRAGMENT_SHADER
    var shader = gl.createShader( type );
    gl.shaderSource( shader, sourceCode );
    gl.compileShader( shader );
    let res = {
        log:  gl.getShaderInfoLog(shader).slice(0, -1),
        status: gl.getShaderParameter(shader, gl.COMPILE_STATUS),
        shader,
    };
    return res;
};

const fragmentPrecision = `
#ifdef GL_ES
  precision mediump float;
#endif
`;